import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import { ApiservicesService } from '../../../../apiservices.service';
import { UserTopComponent } from '../../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../../services/encryptdecrypt.service';


@Component({
  providers: [UserTopComponent],
  selector: 'app-cetak-draf',
  templateUrl: './cetak-draf.component.html',
  styleUrls: ['./cetak-draf.component.css']
})


export class CetakDrafComponent implements OnInit {

  //Session Variables
  SessionFirmID: any;
  SessionStaffID: any;
  SessionAgentID: any;

  //UI Status Varibles
  SearchStatus:boolean = false;
  LoaderStatus: boolean = false;

  //UI Input Variables
  InputTaxRefNum: any = "";

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //UI Temporary Variables
  TempTaxRefNum: any;
  TempStartDate: any;
  TempEndDate: any;

  //Datatable Variables
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  dataSource = new MatTableDataSource();
  displayedColumns = ['taxpayername', 'tin', 'formtype', 'staffname', 'agentname',  'action'];
  RecordCount: any = "";

  constructor(private apiServices: ApiservicesService, private top: UserTopComponent, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.top.updateTotal();
    this.SessionFirmID = Number(this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || ''));
    this.SessionStaffID = Number(this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || ''));
    this.SessionAgentID = Number(this.encryptDecryptService.decrypt(sessionStorage.getItem('TaxAgentID') || ''));
    this.AirDatePickerInit();
  }
  AirDatePickerInit() {
    //const now = new Date();
    new AirDatepicker('#startdate', {
      locale: localeEn,
      dateFormat: "yyyy-MM-dd",
      //minDate: now,
      //isMobile: true,
    })
    new AirDatepicker('#enddate', {
      locale: localeEn,
      dateFormat: "yyyy-MM-dd",
      //minDate: now,
      //isMobile: true,
    })
  }
  Submit(TaxRefNum: any) {
    TaxRefNum = TaxRefNum.toString();
    this.LoaderStatus = true;
    let startdate = document.getElementById('startdate') as HTMLInputElement | null;
    let enddate = document.getElementById('enddate') as HTMLInputElement | null;
    let Params = {};
    if (TaxRefNum === "" && (startdate?.value === "" || enddate?.value === "")) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else if (TaxRefNum !== "" && (startdate?.value === "" || enddate?.value === "")) {
      this.TempTaxRefNum = TaxRefNum;
      this.TempStartDate = null;
      this.TempEndDate = null;
      Params = {
        "SearchType": 1,
        "FirmID": this.SessionFirmID,
        "StaffID": this.SessionStaffID,
        "AgentID": (this.SessionAgentID === "" || this.SessionAgentID === null) ? null : this.SessionAgentID,
        "ITRefNo": String(TaxRefNum),
        "PageNum": 0,
        "PageSize": 10
      };
    } else if (TaxRefNum === "" && (startdate?.value !== "" && enddate?.value !== "")) {
      this.TempTaxRefNum = null;
      this.TempStartDate = startdate?.value;
      this.TempEndDate = enddate?.value;
      Params = {
        "SearchType": 3,
        "FirmID": this.SessionFirmID,
        "StaffID": this.SessionStaffID,
        "AgentID": (this.SessionAgentID === "" || this.SessionAgentID === null) ? null : this.SessionAgentID,
        "DateFrom": startdate?.value,
        "DateTo": enddate?.value,
        "PageNum": 0,
        "PageSize": 10
      };
    }
    this.GetData(Params);
  }
  ViewAll() {
    this.TempTaxRefNum = null;
    this.TempStartDate = null;
    this.TempEndDate = null;
    let Params = {
      "SearchType": 0,
      "FirmID": this.SessionFirmID,
      "StaffID": this.SessionStaffID,
      "AgentID": (this.SessionAgentID === "" || this.SessionAgentID === null) ? null : this.SessionAgentID,
      "PageNum": 0,
      "PageSize": 10
    };
    this.GetData(Params);
    //this.SearchStatus = !this.SearchStatus;
  }
  async GetData(Params: any) {
    const result = await this.apiServices.GetListeDTS(Params);
    if (result.hasError) {
      this.dataSource = new MatTableDataSource();
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
      this.SearchStatus = false;
    } else {
      this.RecordCount = result.totalRecord;
      this.dataSource = new MatTableDataSource(result.eDTS);
      this.SearchStatus = true;
      this.LoaderStatus = false;
    }
  }
  Semula() {
    this.InputTaxRefNum = "";
    this.SearchStatus = false;
    this.LoaderStatus = false;
    this.dataSource = new MatTableDataSource();
    this.RecordCount = "";
    (<HTMLInputElement>document.getElementById('startdate')).value = "";
    (<HTMLInputElement>document.getElementById('enddate')).value = "";
  }
  ResetValue() {
    this.InputTaxRefNum = "";
  }
  paginatorEvent(e: PageEvent) {
    this.LoaderStatus = true;
    let tempSearchType;
    let Params = {};
    if (this.TempTaxRefNum !== null && (this.TempStartDate === null || this.TempEndDate === null))
    {
      tempSearchType = 1;
      Params = {
        "SearchType": tempSearchType,
        "FirmID": this.SessionFirmID,
        "AgentID": (this.SessionAgentID === "" || this.SessionAgentID === null) ? null : this.SessionAgentID,
        "StaffID": this.SessionStaffID,
        "ITRefNo": this.TempTaxRefNum,
        "PageNum": e.pageIndex,
        "PageSize": e.pageSize
      };
    }
    else if (this.TempTaxRefNum === null && (this.TempStartDate !== null && this.TempEndDate !== null))
    {
      tempSearchType = 3;
      Params = {
        "SearchType": tempSearchType,
        "FirmID": this.SessionFirmID,
        "AgentID": (this.SessionAgentID === "" || this.SessionAgentID === null) ? null : this.SessionAgentID,
        "StaffID": this.SessionStaffID,
        "DateFrom": this.TempStartDate,
        "DateTo": this.TempEndDate,
        "PageNum": e.pageIndex,
        "PageSize": e.pageSize
      };
    }
    else
    {
      tempSearchType = 0;
      Params = {
        "SearchType": tempSearchType,
        "FirmID": this.SessionFirmID,
        "AgentID": (this.SessionAgentID === "" || this.SessionAgentID === null) ? null : this.SessionAgentID,
        "StaffID": this.SessionStaffID,
        "PageNum": e.pageIndex,
        "PageSize": e.pageSize
      };
    }
    this.GetData(Params);
  }
  Download(URL:any) {
    window.open(URL, "_blank");
  }
}
